"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Detail = __importStar(require("./detail"));
var DetailUnit = function (_a) {
    var _b, _c;
    var ViewUI = _a.ViewUI, FormUI = _a.FormUI, Data = _a.Data, config = _a.config, data = _a.data;
    var uuid = react_router_dom_1.useParams().uuid;
    var displayType = config.displayType && config.displayType.editType
        ? config.displayType.editType
        : 'toggle';
    if (displayType === 'toggle') {
        return (react_1["default"].createElement(Detail.WToggle, { data: data, id: uuid, ViewUI: ViewUI, FormUI: FormUI, Data: Data, message: (_b = config.customMessages) === null || _b === void 0 ? void 0 : _b.edit }));
    }
    if (displayType === 'view') {
        return react_1["default"].createElement(Detail.JustView, { id: uuid, data: data, ViewUI: ViewUI });
    }
    return (react_1["default"].createElement(Detail.JustForm, { data: data, id: uuid, linkBack: config.urlPrefix, FormUI: FormUI, Data: Data, message: (_c = config.customMessages) === null || _c === void 0 ? void 0 : _c.edit }));
};
exports["default"] = DetailUnit;
